import { useWexCardTransactionQuery } from './api/useWexCardTransactionQuery';
import { WexCardTransactionType } from './types';
import { WexCardTransactionTable } from './WexCardTransactionTable';

type Props = {
  cardId: string;
  activityId: number;
  transactionTypeFilter?: WexCardTransactionType;
  tableHeight?: number;
};

export const VirtualCardTransactionDisplay = ({ cardId, activityId, transactionTypeFilter, tableHeight }: Props) => {
  const { data, isLoading, isError } = useWexCardTransactionQuery(activityId, cardId);
  return (
    <WexCardTransactionTable
      transactions={data}
      isLoading={isLoading}
      isError={isError}
      transactionTypeFilter={transactionTypeFilter}
      tableHeight={tableHeight}
    />
  );
};
